<template>
  <div id="time-line">
    <div style="width: 500px; height: 250px;">
      <dv-border-box-11 title="月度销售情况" style="height: 250px; display: flex; flex-direction: column; justify-content: center">
        <div ref="chartContainer" style="width:480px;height:290px;margin-left: 20px;"></div>
      </dv-border-box-11>
    </div>
    <div style="width: 920px; height: 250px;margin-left: -10px;">
      <dv-border-box-11 title="渠道成交人数:(天)" style="width: 940px; height: 250px;display: flex; flex-direction: column; justify-content: center">
        <div ref="lineChart" style="width:920px;height:220px;margin-left: 10px;margin-top: 20px;"></div>
      </dv-border-box-11>
    </div>
    <div style="width: 500px; height: 250px;margin-left: 10px;">
      <dv-border-box-11 title="商品销售排序" style="height: 250px; display: flex; flex-direction: column; justify-content: center">
        <dv-scroll-ranking-board :config="config" v-if="config.data.length > 0" style="width:450px;height:180px;margin-top: 60px;margin-left: 20px;" />
      </dv-border-box-11>
    </div>

  </div>
</template>

<script>
import * as echarts from 'echarts'
import axios from "axios";
export default {
  data () {
    return {
      // 商品销售排序
      config: {
        data: [],
        maxRows: 3
      }
    }
  },
  mounted() {
    setInterval(this.initChart, 900000);
    // 月度销售情况
    this.initChart()
    setInterval(this.lineChart, 60000);
    // 渠道成交人数
    this.lineChart()
    setInterval(this.productSales, 900000);
    // 商品销售排序
    this.productSales()
  },
  methods: {
    // 月度销售情况
    initChart() {
      axios.post(this.$api+"order/monthlyOrdersNum").then((result) => {
        // 使用Vue的$refs来访问DOM元素
        const chartContainer = this.$refs.chartContainer
        // 初始化echarts实例
        const myChart = echarts.init(chartContainer)

        // 配置项和数据
        var option = {
          tooltip: {},
          xAxis: {
            data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
          },
          yAxis: {},
          series: [
            {
              name: '销量',
              type: 'bar',
              data: result.data
            }
          ]
        }

        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option)
      });
      
    },

    // 渠道成交人数:(天)
    lineChart() {
      axios.post(this.$api+"mallOrder/weeklyOrdersNum").then((result) => {
        // 使用Vue的$refs来访问DOM元素
        const lineChart = this.$refs.lineChart
        // 初始化echarts实例
        const myChart = echarts.init(lineChart)
        var option = {
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: result.data.sky
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: '成交人数',
              type: 'line',
              stack: 'Total',
              data: result.data.value
            }
          ]
        }
        myChart.setOption(option)
      });
    },
    // 商品销售排序
    productSales() {
      axios.post(this.$api+"orderProduct/productSales").then((result) => {
        this.config.data = result.data;
      });
    },
  }
}
</script>

<style lang="less">
  #time-line{
    display: flex;
    width: 100%;
    box-sizing: border-box;
    height: 100%;
    overflow: hidden;
    margin-top: 20px;
  }
</style>
